import {StyleSheet} from 'react-native';

const cardTokeniserTillStyles = StyleSheet.create({
  activity: {
    backgroundColor: 'black',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 400,
    opacity: 0.5,
  },
  button: {
    margin: 8,
    width: 120,
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 16,
  },
  form: {
    backgroundColor: 'white',
    paddingHorizontal: 8,
  },
  formRow: {
    flexDirection: 'row',
  },
  formRowField: {
    width: '100%',
    flex: 1,
  },
  keyAvoidScroll: {
    backgroundColor: 'white',
    borderRadius: 4,
    borderColor: 'grey',
    borderWidth: 0.5,
    paddingVertical: 8,
    paddingHorizontal: 8,
  },
  label: {
    color: 'rgb(134, 147, 158)',
    fontSize: 16,
    fontWeight: 'bold',
    paddingHorizontal: 10,
  },
  tillFieldsWrapper: {
    height: 32,
    paddingHorizontal: 10,
  },
  tillFields: {
    height: 32,
  },
  validationError: {
    fontSize: 12,
    fontWeight: '400',
    color: 'red',
    margin: 5,
    paddingHorizontal: 10,
  },
  webDesktopModalContent: {
    alignItems: 'center',
  },
  webview: {
    fontFamily: 'GrotaSansRd',
  },
});

export default cardTokeniserTillStyles;
